<template>
  <div :class="addCart > 0 ? 'wrapper-cart' : 'wrapper'">
    <!-- <div class="header">

    </div>
    <div class="content">

    </div> -->
    <div v-if="middle"
         class="full">
      <img src="@/assets/smart/bottom_sheet_up_middle.png"
           style="width: 100%;"
           @click="statusChange()" />
    </div>
    <div v-else-if="appFlag !== '1' && upDown"
         class="full">
      <img src="@/assets/smart/bottom_sheet_up_head.png"
           style="width: 100%;"
           @click="statusChange()" />
      <img src="@/assets/smart/bottom_sheet_up_body.png"
           style="width: 100%;" />
      <div class="bottom_sheet_up_foot">
        <img src="@/assets/smart/bottom_sheet_up_foot_close.png"
             class="bottom_sheet_up_foot_close"
             @click="statusChange()" />
        <img src="@/assets/smart/bottom_sheet_up_foot_download.png"
             class="bottom_sheet_up_foot_download"
             @click="moveTerysmsInstall()" />
      </div>
    </div>
    <!-- <div v-else-if="appFlag === '1' && upDown"
         class="full">
      <img src="@/assets/smart/bottom_sheet_up_head.png"
           style="width: 100%;"
           @click="statusChange()" />
      <div class="app_body">
        <img :src="appIcon"
             class="logo"
             @click="statusChange()" />
        <div class="name">{{storeName}}</div>
        <div class="content">
          <span>앱에서만 가능한 혜택을</span>
          <span>확인해 보세요.</span>
        </div>
        <img src="@/assets/smart/btn_smart_sms_app.png"
            class="app_install"
            @click="moveTerysmsInstall()" />
        <div class="devider"></div>
        <div class="close" @click="statusChange()">스마트전단 보기</div>
      </div>
    </div> -->
    <div v-else-if="appFlag === '1' && upDown"
         class="full">
      <img src="@/assets/smart/bottom_sheet_up_head.png"
           style="width: 100%;"
           @click="statusChange()" />
      <div class="app_body">
        <div class="app_top">
          <div v-if="appTotalDiscount <= 0 || $store.state.storeSeq === '051_00000501'" class="content">
            <span>할인부터</span>
            <span>쿠폰까지</span>
          </div>
          <div v-else class="content2">
            <span>쇼핑 할인</span>
            <span>최대</span>
            <span>{{ appTotalDiscount }}원</span>
          </div>
          <div class="img_body">
            <img :src="appIcon"
                 class="logo"
                 @click="statusChange()" />
          </div>
        </div>
        <img src="@/assets/smart/btn_smart_sms_app2.png"
            class="app_install"
            @click="moveTerysmsInstall()" />
        <div class="devider"></div>
        <div class="close" @click="statusChange()">스마트전단 보기</div>
      </div>
    </div>
    <div v-else
         style="width: 100%;"
         @click="statusChange()">
      <img src="@/assets/smart/bottom_sheet_down.png"
           style="width: 100%;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomSheet',
  props: {
    status: Boolean,
    addCart: Number
  },
  computed: {
    appFlag: function () {
      return this.$store.state.storeInfo.APP_FLAG
    },
    appIcon: function () {
      return this.$store.state.storeInfo.STORE_ICON
    },
    appUrl: function () {
      return this.$store.state.storeInfo.APP_URL
    },
    storeName: function () {
      return this.$store.state.storeInfo.STORE_NAME
    },
    appTotalDiscount: function () {
      return this.numberWithCommas2(this.$store.state.appTotalDiscount)
    }
  },
  watch: {
    appFlag () {
      if (this.appFlag === '1' && this.$route.query.seq !== '053_00000105') {
        this.statusChange()
      }
    }
  },
  data () {
    return {
      middle: false,
      upDown: true
    }
  },
  async mounted () {
    const vm = this
    if (
      (!vm.$empty(vm.$route.query.userSeq) && !vm.$empty(vm.$route.query.userPhone)) ||
      vm.$empty(vm.$route.query.bottom) ||
      vm.$route.query.seq === '010_12345777' ||
      vm.$route.query.seq === '051_00000226' ||
      vm.$route.query.seq === '010_12345751' ||
      vm.$route.query.seq === '051_00000790' ||
      vm.$route.query.seq === '054_00000025' ||
      vm.$route.query.seq === '053_00000093' ||
      vm.$route.query.seq === '053_00000097' ||
      vm.$route.query.seq === '051_00000529' ||
      vm.$route.query.seq === '051_00000530' ||
      vm.$route.query.seq === '051_00000536' ||
      vm.$route.query.seq === '051_00000573' ||
      vm.$route.query.seq === '051_00000786' ||
      vm.$route.query.seq === '051_00000787' ||
      vm.$route.query.seq === '051_00000788' ||
      vm.$route.query.seq === '055_00000153' ||
      vm.$route.query.seq === '055_00000222' ||
      vm.$route.query.seq === '055_00000223' ||
      vm.$route.query.seq === '055_00000224' ||
      vm.$route.query.seq === '055_00000229' ||
      vm.$route.query.seq === '070_00000016' ||
      vm.$route.query.seq === '051_00000569' ||
      vm.$route.query.seq === '051_00000723' ||
      vm.$route.query.seq === '051_00000247' ||
      vm.$route.query.seq === '052_00000093' ||
      vm.$route.query.seq === '051_00000644' ||
      vm.$route.query.seq === '051_00000801' ||
      vm.$route.query.seq === '063_00000031' ||
      vm.$route.query.seq === '002_00000008' ||
      vm.$route.query.seq === '000_00000561' ||
      vm.$route.query.seq === '055_00000092' ||
      vm.$route.query.seq === '051_00000376' ||
      vm.$route.query.seq === '051_00000762' ||
      vm.$route.query.seq === '052_00000027' ||
      vm.$route.query.seq === '054_00000028' ||
      vm.$route.query.seq === '051_00000823' ||
      vm.$route.query.seq === '052_00000046' ||
      vm.$route.query.seq === '051_00000798' ||
      vm.$route.query.seq === '052_00000118' ||
      vm.$route.query.seq === '000_00001606' ||
      vm.$route.query.seq === '052_00000026' ||
      vm.$route.query.seq === '051_00000440' ||
      vm.$route.query.seq === '052_00000070' ||
      vm.$route.query.seq === '052_00000109' ||
      vm.$route.query.seq === '053_00000105' ||
      vm.$route.query.seq === '052_00000152' ||
      vm.$route.query.seq === '052_00000153' ||
      vm.$route.query.seq === '051_00000992' ||
      vm.$route.query.seq === '051_00000993' ||
      vm.$route.query.seq === '051_00000994' ||
      vm.$route.query.seq === '166_00000015'
    ) {
      // 가림막 OFF
      vm.$gtag.event('테리문자_가림막_표시', {
        event_category: vm.$route.query.seq,
        event_label: '안함',
        value: vm.$cookies.get('userSeq')
      })
      vm.upDown = false
    } else if (!vm.$empty(vm.$route.query.bottom) && vm.$route.query.bottom === 'full') {
      // 가림막 전체 표시
      vm.$gtag.event('테리문자_가림막_표시', {
        event_category: vm.$route.query.seq,
        event_label: '전체',
        value: vm.$cookies.get('userSeq')
      })
      vm.upDown = vm.status
    } else {
      // 가림막 절반 표시
      vm.$gtag.event('테리문자_가림막_표시', {
        event_category: vm.$route.query.seq,
        event_label: '절반',
        value: vm.$cookies.get('userSeq')
      })
      vm.middle = true
      vm.upDown = false
    }
  },
  methods: {
    statusChange () {
      const vm = this
      if (vm.middle) {
        vm.$gtag.event('테리문자_가림막_상태', {
          event_category: vm.$route.query.seq,
          event_label: '절반-올리기',
          value: vm.$cookies.get('userSeq')
        })
        vm.middle = false
      }
      if (vm.upDown) {
        vm.$gtag.event('테리문자_가림막_상태', {
          event_category: vm.$route.query.seq,
          event_label: '올리기-내리기',
          value: vm.$cookies.get('userSeq')
        })
        vm.upDown = false
      } else {
        vm.$gtag.event('테리문자_가림막_상태', {
          event_category: vm.$route.query.seq,
          event_label: '내리기-올리기',
          value: vm.$cookies.get('userSeq')
        })
        vm.upDown = true
      }
    },
    moveTerysmsInstall () {
      const vm = this
      vm.upDown = false
      if (vm.appFlag === '1') {
        vm.$gtag.event('전용앱_가림막_설치_선택', {
          event_category: vm.$route.query.seq,
          event_label: '전용앱_가림막_설치',
          value: vm.$cookies.get('userSeq')
        })
        window.open(vm.appUrl)
      } else {
        vm.$gtag.event('테리문자_가림막_더알아보기_선택', {
          event_category: vm.$route.query.seq,
          event_label: '테리문자_가림막_배너',
          value: vm.$cookies.get('userSeq')
        })
        window.open('https://tery.kr/install')
      }
    },
    numberWithCommas2 (x) {
      if (!x) {
        return ''
      } else if (x === 0 || x === '0') {
        return ''
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper-cart {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 178px;
  z-index: 100;
}
.wrapper {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 108px;
  z-index: 100;
}
.header {
  width: 28%;
  height: 30px;
  border-radius: 2px;
  background-color: #d0d0d0;
  margin: auto;
}
.full {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottom_sheet_up_foot {
  width: 100%;
  height: 60px;
  background: #000000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 600px) {
  .bottom_sheet_up_foot {
    width: 100%;
    height: 120px;
    background: #000000;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 360px) {
  .bottom_sheet_up_foot {
    width: 100%;
    height: 40px;
    background: #000000;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .app_body {
    .app_top {
      .content {
        width: 60%;
        margin-top: 1.69rem;
        margin-left: 1.38rem;
        display: flex;
        flex-direction: column;
        span:nth-of-type(1) {
          color: #FFF;
          text-align: center;
          font-family: Inter;
          font-size: 2.29163rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%;
        }
        span:nth-of-type(2) {
          color: #FFF;
          font-family: Inter;
          font-size: 2.0rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%;
        }
      }
      .content2 {
        width: 60%;
        margin-top: 1.69rem;
        margin-left: 1.38rem;
        display: flex;
        flex-direction: column;
        span:nth-of-type(1) {
          color: #FFF;
          text-align: center;
          font-family: Inter;
          font-size: 2.29163rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%; /* 4.088rem */
        }
        span:nth-of-type(2) {
          color: #FFF;
          font-family: Inter;
          font-size: 1.375rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%;
        }
        span:nth-of-type(3) {
          color: #FFF;
          font-family: Inter;
          font-size: 2.29163rem;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
    }
  }
}
@media screen and (min-width: 361px) {
  .app_body {
    .app_top {
      .content {
        width: 60%;
        margin-top: 1.69rem;
        margin-left: 1.38rem;
        display: flex;
        flex-direction: column;
        span:nth-of-type(1) {
          color: #FFF;
          text-align: center;
          font-family: Inter;
          font-size: 2.79163rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%;
        }
        span:nth-of-type(2) {
          color: #FFF;
          font-family: Inter;
          font-size: 2.5rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%;
        }
      }
      .content2 {
        width: 60%;
        margin-top: 1.69rem;
        margin-left: 1.38rem;
        display: flex;
        flex-direction: column;
        span:nth-of-type(1) {
          color: #FFF;
          text-align: center;
          font-family: Inter;
          font-size: 2.79163rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%; /* 4.088rem */
        }
        span:nth-of-type(2) {
          color: #FFF;
          font-family: Inter;
          font-size: 1.875rem;
          font-style: normal;
          font-weight: 700;
          line-height: 146.438%;
        }
        span:nth-of-type(3) {
          color: #FFF;
          font-family: Inter;
          font-size: 2.79163rem;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
    }
  }
}
.bottom_sheet_up_foot_close {
  height: 100%;
  object-fit: cover;
  flex: none;
  order: 0;
  flex-grow: 1;
}
.bottom_sheet_up_foot_download {
  height: 100%;
  object-fit: cover;
  flex: none;
  order: 0;
  flex-grow: 1;
}
.app_body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-image: url('../../assets/smart/app_body.png');
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px 8px 0px 0px;
  color: #ffffff;
  .app_top {
    width: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    .img_body {
      width: 30%;
      margin-top: 2rem;
      margin-right: 1.38rem;
      .logo {
        max-width: 5rem;
        height: auto;
        object-fit: contain;
        border-radius: 0.6rem;
      }
    }
  }
  .name {
    height: 60px;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .app_install {
    margin-top: 2rem;
    width: 100%;
    max-width: 300px;
    cursor: pointer;
  }
  .devider {
    margin: 20px;
    width: 60px;
    border: #ffffff solid 1px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .close {
    width: 100%;
    font-size: 16px;
    margin-bottom: 14px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bottomSheet.vue